var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-card-report" },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _vm.loading
            ? _c(
                "div",
                { staticClass: "progressive" },
                [
                  _c("v-progress-circular", {
                    staticClass: "progressbar-top-right",
                    attrs: { size: 40, color: "primary", indeterminate: "" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.highlight && !_vm.loading
            ? _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "yellow" } },
                [_vm._v("\n      star\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tooltip && !_vm.loading
            ? _c(
                "v-tooltip",
                { attrs: { top: "" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "info-card",
                      attrs: { slot: "activator" },
                      slot: "activator",
                    },
                    [_vm._v("\n        info_outline\n      ")]
                  ),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("\n        " + _vm._s(_vm.tooltip) + "\n      "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-card-text", [
            _vm.showLastWeek
              ? _c("div", { staticClass: "date" }, [
                  _c("span", [
                    _vm._v(
                      " Total dos últimos 7 dias: " +
                        _vm._s(_vm.item.lastWeek) +
                        " "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm.item.icon
                ? _c(
                    "div",
                    { staticClass: "icon" },
                    [_c("v-icon", [_vm._v(_vm._s(_vm.item.icon))])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c("span", { staticClass: "d-block card-report-title" }, [
                  _vm._v(
                    "\n            " + _vm._s(_vm.item.title) + "\n            "
                  ),
                  _c("span", { staticClass: "card-report-complement" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.item.complement) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "d-block card-report-general" }, [
                  _vm._v(_vm._s(_vm.item.general)),
                ]),
                _vm._v(" "),
                _vm.item.sdzToBRL
                  ? _c("span", [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.item.sdzToBRL) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }